module.exports = __webpack_public_path__ + "img/compact.f2687bcb.png";